import { render } from "./tesList.vue?vue&type=template&id=19e13aef"
import script from "./tesList.vue?vue&type=script&lang=js"
export * from "./tesList.vue?vue&type=script&lang=js"

import "./tesList.vue?vue&type=style&index=0&id=19e13aef&lang=scss"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__